// @generated by protobuf-ts 2.11.1 with parameter server_generic,generate_dependencies,long_type_number
// @generated from protobuf file "packages/dht/protos/DhtRpc.proto" (package "dht", syntax proto3)
// tslint:disable
import { Empty } from "../../../google/protobuf/empty";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { RpcMessage } from "../../proto-rpc/protos/ProtoRpc";
import { Timestamp } from "../../../google/protobuf/timestamp";
import { Any } from "../../../google/protobuf/any";
/**
 * @generated from protobuf enum dht.RecursiveOperation
 */
export var RecursiveOperation;
(function (RecursiveOperation) {
    /**
     * @generated from protobuf enum value: FIND_CLOSEST_NODES = 0;
     */
    RecursiveOperation[RecursiveOperation["FIND_CLOSEST_NODES"] = 0] = "FIND_CLOSEST_NODES";
    /**
     * @generated from protobuf enum value: FETCH_DATA = 1;
     */
    RecursiveOperation[RecursiveOperation["FETCH_DATA"] = 1] = "FETCH_DATA";
    /**
     * @generated from protobuf enum value: DELETE_DATA = 2;
     */
    RecursiveOperation[RecursiveOperation["DELETE_DATA"] = 2] = "DELETE_DATA";
})(RecursiveOperation || (RecursiveOperation = {}));
/**
 * @generated from protobuf enum dht.NodeType
 */
export var NodeType;
(function (NodeType) {
    /**
     * @generated from protobuf enum value: NODEJS = 0;
     */
    NodeType[NodeType["NODEJS"] = 0] = "NODEJS";
    /**
     * @generated from protobuf enum value: BROWSER = 1;
     */
    NodeType[NodeType["BROWSER"] = 1] = "BROWSER";
})(NodeType || (NodeType = {}));
/**
 * @generated from protobuf enum dht.RpcResponseError
 */
export var RpcResponseError;
(function (RpcResponseError) {
    /**
     * @generated from protobuf enum value: SERVER_TIMOUT = 0;
     */
    RpcResponseError[RpcResponseError["SERVER_TIMOUT"] = 0] = "SERVER_TIMOUT";
    /**
     * @generated from protobuf enum value: CLIENT_TIMEOUT = 1;
     */
    RpcResponseError[RpcResponseError["CLIENT_TIMEOUT"] = 1] = "CLIENT_TIMEOUT";
    /**
     * @generated from protobuf enum value: SERVER_ERROR = 2;
     */
    RpcResponseError[RpcResponseError["SERVER_ERROR"] = 2] = "SERVER_ERROR";
    /**
     * @generated from protobuf enum value: UNKNOWN_RPC_METHOD = 3;
     */
    RpcResponseError[RpcResponseError["UNKNOWN_RPC_METHOD"] = 3] = "UNKNOWN_RPC_METHOD";
})(RpcResponseError || (RpcResponseError = {}));
/**
 * @generated from protobuf enum dht.RouteMessageError
 */
export var RouteMessageError;
(function (RouteMessageError) {
    /**
     * @generated from protobuf enum value: NO_TARGETS = 0;
     */
    RouteMessageError[RouteMessageError["NO_TARGETS"] = 0] = "NO_TARGETS";
    /**
     * @generated from protobuf enum value: DUPLICATE = 1;
     */
    RouteMessageError[RouteMessageError["DUPLICATE"] = 1] = "DUPLICATE";
    /**
     * TODO: can this be removed? If DhtNode is already stopped the server side requests
     * should not be processed
     *
     * @generated from protobuf enum value: STOPPED = 2;
     */
    RouteMessageError[RouteMessageError["STOPPED"] = 2] = "STOPPED";
})(RouteMessageError || (RouteMessageError = {}));
/**
 * @generated from protobuf enum dht.HandshakeError
 */
export var HandshakeError;
(function (HandshakeError) {
    /**
     * @generated from protobuf enum value: DUPLICATE_CONNECTION = 0;
     */
    HandshakeError[HandshakeError["DUPLICATE_CONNECTION"] = 0] = "DUPLICATE_CONNECTION";
    /**
     * @generated from protobuf enum value: INVALID_TARGET_PEER_DESCRIPTOR = 1;
     */
    HandshakeError[HandshakeError["INVALID_TARGET_PEER_DESCRIPTOR"] = 1] = "INVALID_TARGET_PEER_DESCRIPTOR";
    /**
     * @generated from protobuf enum value: UNSUPPORTED_PROTOCOL_VERSION = 2;
     */
    HandshakeError[HandshakeError["UNSUPPORTED_PROTOCOL_VERSION"] = 2] = "UNSUPPORTED_PROTOCOL_VERSION";
})(HandshakeError || (HandshakeError = {}));
/**
 * @generated from protobuf enum dht.DisconnectMode
 */
export var DisconnectMode;
(function (DisconnectMode) {
    /**
     * @generated from protobuf enum value: NORMAL = 0;
     */
    DisconnectMode[DisconnectMode["NORMAL"] = 0] = "NORMAL";
    /**
     * @generated from protobuf enum value: LEAVING = 1;
     */
    DisconnectMode[DisconnectMode["LEAVING"] = 1] = "LEAVING";
})(DisconnectMode || (DisconnectMode = {}));
// @generated message type with reflection information, may provide speed optimized methods
class StoreDataRequest$Type extends MessageType {
    constructor() {
        super("dht.StoreDataRequest", [
            { no: 1, name: "key", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 2, name: "data", kind: "message", T: () => Any },
            { no: 3, name: "creator", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 4, name: "createdAt", kind: "message", T: () => Timestamp },
            { no: 5, name: "ttl", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dht.StoreDataRequest
 */
export const StoreDataRequest = new StoreDataRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StoreDataResponse$Type extends MessageType {
    constructor() {
        super("dht.StoreDataResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message dht.StoreDataResponse
 */
export const StoreDataResponse = new StoreDataResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExternalStoreDataRequest$Type extends MessageType {
    constructor() {
        super("dht.ExternalStoreDataRequest", [
            { no: 1, name: "key", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 2, name: "data", kind: "message", T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dht.ExternalStoreDataRequest
 */
export const ExternalStoreDataRequest = new ExternalStoreDataRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExternalStoreDataResponse$Type extends MessageType {
    constructor() {
        super("dht.ExternalStoreDataResponse", [
            { no: 1, name: "storers", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PeerDescriptor }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dht.ExternalStoreDataResponse
 */
export const ExternalStoreDataResponse = new ExternalStoreDataResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReplicateDataRequest$Type extends MessageType {
    constructor() {
        super("dht.ReplicateDataRequest", [
            { no: 1, name: "entry", kind: "message", T: () => DataEntry }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dht.ReplicateDataRequest
 */
export const ReplicateDataRequest = new ReplicateDataRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DataEntry$Type extends MessageType {
    constructor() {
        super("dht.DataEntry", [
            { no: 1, name: "key", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 2, name: "data", kind: "message", T: () => Any },
            { no: 3, name: "creator", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 4, name: "createdAt", kind: "message", T: () => Timestamp },
            { no: 5, name: "storedAt", kind: "message", T: () => Timestamp },
            { no: 6, name: "ttl", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 7, name: "stale", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "deleted", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dht.DataEntry
 */
export const DataEntry = new DataEntry$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ClosestPeersRequest$Type extends MessageType {
    constructor() {
        super("dht.ClosestPeersRequest", [
            { no: 1, name: "nodeId", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 2, name: "requestId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dht.ClosestPeersRequest
 */
export const ClosestPeersRequest = new ClosestPeersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ClosestPeersResponse$Type extends MessageType {
    constructor() {
        super("dht.ClosestPeersResponse", [
            { no: 1, name: "peers", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PeerDescriptor },
            { no: 2, name: "requestId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dht.ClosestPeersResponse
 */
export const ClosestPeersResponse = new ClosestPeersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ClosestRingPeersRequest$Type extends MessageType {
    constructor() {
        super("dht.ClosestRingPeersRequest", [
            { no: 1, name: "ringId", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 2, name: "requestId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dht.ClosestRingPeersRequest
 */
export const ClosestRingPeersRequest = new ClosestRingPeersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ClosestRingPeersResponse$Type extends MessageType {
    constructor() {
        super("dht.ClosestRingPeersResponse", [
            { no: 1, name: "leftPeers", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PeerDescriptor },
            { no: 2, name: "rightPeers", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PeerDescriptor },
            { no: 3, name: "requestId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dht.ClosestRingPeersResponse
 */
export const ClosestRingPeersResponse = new ClosestRingPeersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RecursiveOperationRequest$Type extends MessageType {
    constructor() {
        super("dht.RecursiveOperationRequest", [
            { no: 1, name: "sessionId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "operation", kind: "enum", T: () => ["dht.RecursiveOperation", RecursiveOperation] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dht.RecursiveOperationRequest
 */
export const RecursiveOperationRequest = new RecursiveOperationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RecursiveOperationResponse$Type extends MessageType {
    constructor() {
        super("dht.RecursiveOperationResponse", [
            { no: 1, name: "closestConnectedNodes", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PeerDescriptor },
            { no: 2, name: "dataEntries", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => DataEntry },
            { no: 3, name: "noCloserNodesFound", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "routingPath", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PeerDescriptor }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dht.RecursiveOperationResponse
 */
export const RecursiveOperationResponse = new RecursiveOperationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PingRequest$Type extends MessageType {
    constructor() {
        super("dht.PingRequest", [
            { no: 1, name: "requestId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dht.PingRequest
 */
export const PingRequest = new PingRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PingResponse$Type extends MessageType {
    constructor() {
        super("dht.PingResponse", [
            { no: 1, name: "requestId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dht.PingResponse
 */
export const PingResponse = new PingResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LeaveNotice$Type extends MessageType {
    constructor() {
        super("dht.LeaveNotice", []);
    }
}
/**
 * @generated MessageType for protobuf message dht.LeaveNotice
 */
export const LeaveNotice = new LeaveNotice$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PeerDescriptor$Type extends MessageType {
    constructor() {
        super("dht.PeerDescriptor", [
            { no: 1, name: "nodeId", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 2, name: "type", kind: "enum", T: () => ["dht.NodeType", NodeType] },
            { no: 3, name: "udp", kind: "message", T: () => ConnectivityMethod },
            { no: 4, name: "tcp", kind: "message", T: () => ConnectivityMethod },
            { no: 5, name: "websocket", kind: "message", T: () => ConnectivityMethod },
            { no: 6, name: "region", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ },
            { no: 7, name: "ipAddress", kind: "scalar", opt: true, T: 13 /*ScalarType.UINT32*/ },
            { no: 8, name: "publicKey", kind: "scalar", opt: true, T: 12 /*ScalarType.BYTES*/ },
            { no: 9, name: "signature", kind: "scalar", opt: true, T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dht.PeerDescriptor
 */
export const PeerDescriptor = new PeerDescriptor$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectivityMethod$Type extends MessageType {
    constructor() {
        super("dht.ConnectivityMethod", [
            { no: 1, name: "port", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "host", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "tls", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dht.ConnectivityMethod
 */
export const ConnectivityMethod = new ConnectivityMethod$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RouteMessageWrapper$Type extends MessageType {
    constructor() {
        super("dht.RouteMessageWrapper", [
            { no: 1, name: "requestId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "sourcePeer", kind: "message", T: () => PeerDescriptor },
            { no: 3, name: "target", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 4, name: "message", kind: "message", T: () => Message },
            { no: 5, name: "reachableThrough", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PeerDescriptor },
            { no: 6, name: "routingPath", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PeerDescriptor },
            { no: 7, name: "parallelRootNodeIds", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dht.RouteMessageWrapper
 */
export const RouteMessageWrapper = new RouteMessageWrapper$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RouteMessageAck$Type extends MessageType {
    constructor() {
        super("dht.RouteMessageAck", [
            { no: 1, name: "requestId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "error", kind: "enum", opt: true, T: () => ["dht.RouteMessageError", RouteMessageError] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dht.RouteMessageAck
 */
export const RouteMessageAck = new RouteMessageAck$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectivityRequest$Type extends MessageType {
    constructor() {
        super("dht.ConnectivityRequest", [
            { no: 1, name: "port", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "tls", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "host", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "allowSelfSignedCertificate", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dht.ConnectivityRequest
 */
export const ConnectivityRequest = new ConnectivityRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectivityResponse$Type extends MessageType {
    constructor() {
        super("dht.ConnectivityResponse", [
            { no: 1, name: "host", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "natType", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "websocket", kind: "message", T: () => ConnectivityMethod },
            { no: 4, name: "ipAddress", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 5, name: "protocolVersion", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "latitude", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "longitude", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dht.ConnectivityResponse
 */
export const ConnectivityResponse = new ConnectivityResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HandshakeRequest$Type extends MessageType {
    constructor() {
        super("dht.HandshakeRequest", [
            { no: 1, name: "sourcePeerDescriptor", kind: "message", T: () => PeerDescriptor },
            { no: 2, name: "targetPeerDescriptor", kind: "message", T: () => PeerDescriptor },
            { no: 3, name: "protocolVersion", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "applicationVersion", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dht.HandshakeRequest
 */
export const HandshakeRequest = new HandshakeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HandshakeResponse$Type extends MessageType {
    constructor() {
        super("dht.HandshakeResponse", [
            { no: 1, name: "sourcePeerDescriptor", kind: "message", T: () => PeerDescriptor },
            { no: 2, name: "error", kind: "enum", opt: true, T: () => ["dht.HandshakeError", HandshakeError] },
            { no: 3, name: "protocolVersion", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "applicationVersion", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dht.HandshakeResponse
 */
export const HandshakeResponse = new HandshakeResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Message$Type extends MessageType {
    constructor() {
        super("dht.Message", [
            { no: 1, name: "messageId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "sourceDescriptor", kind: "message", T: () => PeerDescriptor },
            { no: 3, name: "targetDescriptor", kind: "message", T: () => PeerDescriptor },
            { no: 4, name: "serviceId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "rpcMessage", kind: "message", oneof: "body", T: () => RpcMessage },
            { no: 6, name: "connectivityRequest", kind: "message", oneof: "body", T: () => ConnectivityRequest },
            { no: 7, name: "connectivityResponse", kind: "message", oneof: "body", T: () => ConnectivityResponse },
            { no: 8, name: "handshakeRequest", kind: "message", oneof: "body", T: () => HandshakeRequest },
            { no: 9, name: "handshakeResponse", kind: "message", oneof: "body", T: () => HandshakeResponse },
            { no: 10, name: "recursiveOperationRequest", kind: "message", oneof: "body", T: () => RecursiveOperationRequest }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dht.Message
 */
export const Message = new Message$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebsocketConnectionRequest$Type extends MessageType {
    constructor() {
        super("dht.WebsocketConnectionRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message dht.WebsocketConnectionRequest
 */
export const WebsocketConnectionRequest = new WebsocketConnectionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebrtcConnectionRequest$Type extends MessageType {
    constructor() {
        super("dht.WebrtcConnectionRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message dht.WebrtcConnectionRequest
 */
export const WebrtcConnectionRequest = new WebrtcConnectionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RtcOffer$Type extends MessageType {
    constructor() {
        super("dht.RtcOffer", [
            { no: 1, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "connectionId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dht.RtcOffer
 */
export const RtcOffer = new RtcOffer$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RtcAnswer$Type extends MessageType {
    constructor() {
        super("dht.RtcAnswer", [
            { no: 1, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "connectionId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dht.RtcAnswer
 */
export const RtcAnswer = new RtcAnswer$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IceCandidate$Type extends MessageType {
    constructor() {
        super("dht.IceCandidate", [
            { no: 1, name: "candidate", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "mid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "connectionId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dht.IceCandidate
 */
export const IceCandidate = new IceCandidate$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LockRequest$Type extends MessageType {
    constructor() {
        super("dht.LockRequest", [
            { no: 1, name: "lockId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dht.LockRequest
 */
export const LockRequest = new LockRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UnlockRequest$Type extends MessageType {
    constructor() {
        super("dht.UnlockRequest", [
            { no: 1, name: "lockId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dht.UnlockRequest
 */
export const UnlockRequest = new UnlockRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LockResponse$Type extends MessageType {
    constructor() {
        super("dht.LockResponse", [
            { no: 1, name: "accepted", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dht.LockResponse
 */
export const LockResponse = new LockResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DisconnectNotice$Type extends MessageType {
    constructor() {
        super("dht.DisconnectNotice", [
            { no: 1, name: "disconnectMode", kind: "enum", T: () => ["dht.DisconnectMode", DisconnectMode] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dht.DisconnectNotice
 */
export const DisconnectNotice = new DisconnectNotice$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetPrivateRequest$Type extends MessageType {
    constructor() {
        super("dht.SetPrivateRequest", [
            { no: 1, name: "isPrivate", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dht.SetPrivateRequest
 */
export const SetPrivateRequest = new SetPrivateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExternalFetchDataRequest$Type extends MessageType {
    constructor() {
        super("dht.ExternalFetchDataRequest", [
            { no: 1, name: "key", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dht.ExternalFetchDataRequest
 */
export const ExternalFetchDataRequest = new ExternalFetchDataRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExternalFetchDataResponse$Type extends MessageType {
    constructor() {
        super("dht.ExternalFetchDataResponse", [
            { no: 1, name: "entries", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => DataEntry }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dht.ExternalFetchDataResponse
 */
export const ExternalFetchDataResponse = new ExternalFetchDataResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExternalFindClosestNodesRequest$Type extends MessageType {
    constructor() {
        super("dht.ExternalFindClosestNodesRequest", [
            { no: 1, name: "nodeId", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dht.ExternalFindClosestNodesRequest
 */
export const ExternalFindClosestNodesRequest = new ExternalFindClosestNodesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExternalFindClosestNodesResponse$Type extends MessageType {
    constructor() {
        super("dht.ExternalFindClosestNodesResponse", [
            { no: 1, name: "closestNodes", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PeerDescriptor }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message dht.ExternalFindClosestNodesResponse
 */
export const ExternalFindClosestNodesResponse = new ExternalFindClosestNodesResponse$Type();
/**
 * @generated ServiceType for protobuf service dht.DhtNodeRpc
 */
export const DhtNodeRpc = new ServiceType("dht.DhtNodeRpc", [
    { name: "getClosestPeers", options: {}, I: ClosestPeersRequest, O: ClosestPeersResponse },
    { name: "getClosestRingPeers", options: {}, I: ClosestRingPeersRequest, O: ClosestRingPeersResponse },
    { name: "ping", options: {}, I: PingRequest, O: PingResponse },
    { name: "leaveNotice", options: {}, I: LeaveNotice, O: Empty }
]);
/**
 * @generated ServiceType for protobuf service dht.RouterRpc
 */
export const RouterRpc = new ServiceType("dht.RouterRpc", [
    { name: "routeMessage", options: {}, I: RouteMessageWrapper, O: RouteMessageAck },
    { name: "forwardMessage", options: {}, I: RouteMessageWrapper, O: RouteMessageAck }
]);
/**
 * @generated ServiceType for protobuf service dht.RecursiveOperationRpc
 */
export const RecursiveOperationRpc = new ServiceType("dht.RecursiveOperationRpc", [
    { name: "routeRequest", options: {}, I: RouteMessageWrapper, O: RouteMessageAck }
]);
/**
 * @generated ServiceType for protobuf service dht.StoreRpc
 */
export const StoreRpc = new ServiceType("dht.StoreRpc", [
    { name: "storeData", options: {}, I: StoreDataRequest, O: StoreDataResponse },
    { name: "replicateData", options: {}, I: ReplicateDataRequest, O: Empty }
]);
/**
 * @generated ServiceType for protobuf service dht.RecursiveOperationSessionRpc
 */
export const RecursiveOperationSessionRpc = new ServiceType("dht.RecursiveOperationSessionRpc", [
    { name: "sendResponse", options: {}, I: RecursiveOperationResponse, O: Empty }
]);
/**
 * @generated ServiceType for protobuf service dht.WebsocketClientConnectorRpc
 */
export const WebsocketClientConnectorRpc = new ServiceType("dht.WebsocketClientConnectorRpc", [
    { name: "requestConnection", options: {}, I: WebsocketConnectionRequest, O: Empty }
]);
/**
 * @generated ServiceType for protobuf service dht.WebrtcConnectorRpc
 */
export const WebrtcConnectorRpc = new ServiceType("dht.WebrtcConnectorRpc", [
    { name: "requestConnection", options: {}, I: WebrtcConnectionRequest, O: Empty },
    { name: "rtcOffer", options: {}, I: RtcOffer, O: Empty },
    { name: "rtcAnswer", options: {}, I: RtcAnswer, O: Empty },
    { name: "iceCandidate", options: {}, I: IceCandidate, O: Empty }
]);
/**
 * @generated ServiceType for protobuf service dht.ConnectionLockRpc
 */
export const ConnectionLockRpc = new ServiceType("dht.ConnectionLockRpc", [
    { name: "lockRequest", options: {}, I: LockRequest, O: LockResponse },
    { name: "unlockRequest", options: {}, I: UnlockRequest, O: Empty },
    { name: "gracefulDisconnect", options: {}, I: DisconnectNotice, O: Empty },
    { name: "setPrivate", options: {}, I: SetPrivateRequest, O: Empty }
]);
/**
 * @generated ServiceType for protobuf service dht.ExternalApiRpc
 */
export const ExternalApiRpc = new ServiceType("dht.ExternalApiRpc", [
    { name: "externalFetchData", options: {}, I: ExternalFetchDataRequest, O: ExternalFetchDataResponse },
    { name: "externalStoreData", options: {}, I: ExternalStoreDataRequest, O: ExternalStoreDataResponse },
    { name: "externalFindClosestNodes", options: {}, I: ExternalFindClosestNodesRequest, O: ExternalFindClosestNodesResponse }
]);
